import _ from 'underscore';
/**
 * This function loads the inline manual for a particular key only once, and returns a promise that resolves
 * when the manual is loaded, or rejects if it isn't loaded after 10 seconds
 */
const scriptPromises = {};
function loadInlineManual(key) {
  if (typeof key !== 'string') {
    return Promise.reject(new Error('invalid inline manual key'));
  }

  if (scriptPromises[ key ]) {
    return scriptPromises[ key ];
  }

  scriptPromises[ key ] = new Promise((resolve, reject) => {
    const e = document.createElement('script');
    const t = document.getElementsByTagName('script')[ 0 ];

    e.async = 1;
    e.src = `https://inlinemanual.com/embed/player.${key}.bare.js`;
    e.charset = 'UTF-8';
    t.parentNode.insertBefore(e, t);

    let numIntervals = 0;
    const interval = setInterval(
      () => {
        if (typeof createInlineManualPlayer === 'function') {
          clearInterval(interval);
          resolve();
        } else if (numIntervals + 1 > 10) {
          numIntervals += 1;
          clearInterval(interval);
          reject(new Error('script did not load'));
        }
      },
      1000
    );
  });

  return scriptPromises[ key ];
}

/**
 * This function should be called to initialize the inline manual for a user
 * @param inlineManualKey
 * @param user that we are initializing tracking for
 * @returns {Promise.<TResult>}
 */
let initializePromise = null;
export function initializeInlineManualTracking(inlineManualKey, user, userAccess) {
  if (typeof user !== 'object' || typeof user.id !== 'string') {
    return Promise.reject(new Error('invalid user!'));
  }

  // update the tracking object
  window.inlineManualTracking = { ...user, uid: user.id, group: userAccess };

  // if we've initialized before, update the player and then return it
  if (initializePromise) {
    initializePromise = initializePromise
      .then(manual => {
        manual.update();
        return manual;
      });
  } else {
    // otherwise load the manual and create it
    initializePromise = loadInlineManual(inlineManualKey)
      .then(() => createInlineManualPlayer(window.inlineManualPlayerData));
  }

  return initializePromise;
}


// WEBPACK FOOTER //
// ./src/js/util/InlineManualUtil.js